export default __webpack_public_path__ + "8a71361.png";